export const endpoints = {
  v1: {
    sessions_filters: '/sessions/filters',
    chargers_config_chargerId: '/chargers/config/{chargerId}',
    users_chargers_bulkAdd: '/users/chargers/bulk-add',
    users_data_userId: '/users/data/{userId}'
  },
  v2: {
    currencies: 'v2/currencies',
    countries: 'v2/countries',
    countries_countryCode_states: 'v2/countries/{countryCode}/states',
    charger_chargerId: 'v2/charger/{chargerId}',
    charger_chargerId_group: 'v2/charger/{chargerId}/group',
    user_userId: 'v2/user/{userId}',
    user_userId_assignGroup_groupId: 'v2/user/{userId}/assign-group/{groupId}',
    usersUserIdPassword: '/v2/users/{userId}/password',
    passwordReset: '/v2/users/password/reset'
  },
  v3: {
    groups_groupId_invoices: 'v3/groups/{groupId}/invoices',
    groups_groupId_billingInfo: 'v3/groups/{groupId}/billing-info',
    invoices_invoiceId_payments: 'v3/invoices/{invoiceId}/pay',
    systemFormats: 'v3/system-formats',
    chargers_groups: 'v3/chargers/groups',
    chargers_group: 'v3/groups/{groupId}',
    chargers_chargerId_remoteAction: 'v3/chargers/{chargerId}/remote-action',
    groups_groupId: 'v3/groups/{groupId}',
    groups: 'v3/groups',
    chargers: 'v3/chargers',
    chargers_chargerId: 'v3/chargers/{chargerId}',
    chargers_chargerId_checkUpdates: 'v3/chargers/{chargerId}/check-updates',
    chargers_chargerId_ocppConfiguration: 'v3/chargers/{chargerId}/ocpp-configuration',
    users_groups: 'v3/users/groups',
    access: 'v3/access',
    accessConfigs: 'v3/access-configs',
    accessConfigs_accessConfigId: 'v3/access-configs/{accessConfigId}',
    add_users_to_access_config: 'v3/users/invite',
    accessConfigs_accessConfigId_users_userId: 'v3/access-configs/{accessConfigId}/users/{userId}',
    accessConfigs_accessConfigId_users_userId_profile: 'v3/access-configs/{accessConfigId}/users/{userId}/profile',
    contracts_contractId: 'v3/contracts/{contractId}',
    users_contracts_contractId_active: 'v3/contracts/{contractId}/activate',
    create_new_user: '/v3/users'
  },

  v4: {
    application_fees: 'v4/application-fees',
    commissioning_transfers_token: 'v4/commissioning/transfers/{token}',
    commissioning_transfers_token_accept: 'v4/commissioning/transfers/{token}/accept',
    commissioning_transfers_token_reject: 'v4/commissioning/transfers/{token}/reject',
    chargers_timezones: 'v4/chargers/timezones',
    groups_groupId_invitations: 'v4/groups/{groupId}/invitations',
    chargers_last_sessions: '/v4/charger-last-sessions',
    groups_groupId_invitations_invitationId: 'v4/groups/{groupId}/invitations/{invitationId}',
    groups_groupId_payment_account: 'v4/groups/{groupId}/payment-account',
    groups_groupId_payment_account_link: 'v4/groups/{groupId}/payment-account-link',
    chargers_groups: '/v4/groups/{groupUid}/chargers',
    spaces: '/v4/space-accesses',
    payments_invoices_void: '/v4/invoices/{invoiceId}/void',
    user_ulid_id: '/v4/users/{ulid}/id',
    groups_groupId_charger_charging_sessions: '/v4/groups/{groupId}/charger-charging-sessions',
    operator_request: 'v4/operator-request',
    operator_request_uid: 'v4/operator-request/{operatorRequestUid}',
    group_rates: '/v4/groups/{groupId}/rates',
    group_rate: '/v4/groups/{groupId}/rates/{rateId}',
    get_locations: '/v4/spaces/{organizationUid}/locations',
    locations: '/v4/locations',
    location: '/v4/locations/{locationUid}',
    group_id: '/v4/groups/{groupUid}/id',
    config: '/v4/app/config',
    fee_invoices: '/v4/organizations/{organizationUid}/wallbox-fee-invoices',
    fee_invoice_details: '/v4/organizations/{organizationUid}/wallbox-fee-invoices/{invoiceNumber}',
    chargers_charger_rate_schedules: '/v4/chargers/{chargerUid}/charger-rate-schedules',
    chargers_charger_rate_schedule_id: '/v4/chargers/{chargerUid}/charger-rate-schedules/{scheduleId}',
    organizations_invoices: 'v4/organizations/{groupUid}/invoices',
    organizations_assigned_rates: 'v4/organizations/{groupUid}/assigned-rates/{rateUid}',
    charger_chargerUid_id: '/v4/chargers/{chargerUid}/id',
    charger_active_sessions: '/v4/chargers/active-session/group/{organizationId}',
    charge_points_commissioning_wizard_info: '/v4/charge-points/commissioning-wizard-info',
    charge_points: '/v4/charge-points',
    locations_locationId_charge_point: '/v4/locations/{locationId}/charge-points',
    organizations_groupUid_charge_points: '/v4/organizations/{groupUid}/charge-points',
    charge_points_chargePointId_connectors: '/v4/charge-points/{chargePointId}/connectors',
    charger_chargerUid_charger_serviceabilities: '/v4/chargers/{chargerUid}/charger-serviceabilities',
    charger_chargerServiceabilityUid_accept: '/v4/charger-serviceabilities/{chargerServiceabilityUid}/accept',
    charger_chargerServiceabilityUid_revoke: '/v4/charger-serviceabilities/{chargerServiceabilityUid}/revoke',
    organization: '/v4/organizations/{groupUid}',
    organizations: '/v4/organizations'
  },

  perseus: {
    organization: '/organizations/{groupUid}',
    organizations: '/organizations'
  },

  userApi: {
    userEmail: '/users/emails/{email}',
    signIn: '/users/signin',
    create: '/users',
    passwordResetRequest: '/users/password/reset/email',
    passwordReset: '/users/password/reset',
    oauthSignin: '/users/signin/{provider}',
    activateUser: '/users/activate',
    oauthSignup: '/users/{provider}',
    refreshToken: '/users/refresh-token',
    usersUserIdPassword: '/users/{userId}/password',
    usersMe: '/users/me',
    usersUserIdAvatar: '/users/{userId}/avatar',
    userUserId: '/users/{userId}',
    signout: '/users/signout'
  }
}
